export interface StringMap {
  [prop: string]: string;
}

export const BRANCHES = {
  'escapemasters.co.nz': 'Auckland',
  'rotorua.escapemasters.co.nz': 'Rotorua',
  'test.escroomapp.com': 'Test',
  'manukau.escapemasters.co.nz': 'Manukau',
  'wellington.escapemasters.co.nz': 'Wellington',
} as StringMap;
